import { Box, styled } from "@mui/material";
import { BORDER_COLOR } from "../../theme";

export const styles = {
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    height: "20vh",
    alignItems: "center",
  } as const,
  noShareFoundBox: {
    height: "20vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  infoCircle: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '17px',
    height: '17px',
    backgroundColor: 'grey',
    color: 'white',
    borderRadius: '50%',
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center',
    cursor: 'pointer',
    marginLeft: "5px"
  } as const,
};

export const TableTitleContainer = styled(Box)(({ theme }) => ({
  marginTop: "20px",
  display: "flex",
  justifyContent: "space-between",
  padding: "15px",
  backgroundColor: "#1F242F",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const TableScrollContainer = styled(Box)(({ theme }) => ({
  maxHeight: "82vh",
  overflowY: "scroll",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  [theme.breakpoints.down("md")]: {
    marginTop: "20px",
  },
}));

export const ShareContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "20px",
  border: `1px solid ${BORDER_COLOR}`,
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const ExpiryDateContainer = styled(Box)(({ theme }) => ({
  width: "180px",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const MaxViewsContainer = styled(Box)(({ theme }) => ({
  minWidth: "50px",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
  display: 'flex',
  justifyContent: "center"
}));

export const ViewsContainer = styled(Box)(({ theme }) => ({
  minWidth: "50px",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
  display: 'flex',
  justifyContent: "center"
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  width: "130px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const DescriptionContainer = styled(Box)(({ theme }) => ({
  width: "16%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));
